import React from 'react';
export function SelfDefenseFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-2974">
      Frequently Asked Questions
    </h2>;
}